import request from './request';

export default (resource) => ({
  customPost(payload) {
    return request.post(`/${resource}/`, payload);
  },

  customPut(payload) {
    return request.put(`/${resource}/`, payload);
  },

  index(query) {
    return request.get(`/${resource}/`, { params: query });
  },

  indexInPath(path, query) {
    return request.get(`/${resource}/${path}/`, { params: query });
  },

  postInPath(path, payload) {
    return request.post(`/${resource}/${path}/`, payload);
  },

  postInResourcePath(id, path, payload) {
    return request.post(`/${resource}/${id}/${path}/`, payload);
  },

  create(payload) {
    return request.post(`/${resource}/`, payload);
  },

  show(id) {
    return request.get(`/${resource}/${id}/`);
  },

  showInPath(path, id, query) {
    return request.get(`/${resource}/${path}/${id}/`, { params: query });
  },

  showPathInPath(path1, id, path2) {
    return request.get(`/${resource}/${path1}/${id}/${path2}`);
  },

  postPathInPath(path1, id, path2) {
    return request.post(`/${resource}/${path1}/${id}/${path2}/`);
  },

  showPath(id, path) {
    return request.get(`/${resource}/${id}/${path}/`);
  },

  update(payload) {
    return request.put(`/${resource}/`, payload);
  },

  updateInPath(path, payload) {
    return request.put(`/${resource}/${path}/`, payload);
  },

  updateInNestedPath(path, id, payload) {
    return request.put(`/${resource}/${path}/${id}/`, payload);
  },

  patch(payload) {
    return request.patch(`/${resource}/`, payload);
  },

  patchInPath(path, payload) {
    return request.patch(`/${resource}/${path}/`, payload);
  },

  delete(id) {
    return request.delete(`/${resource}/${id}/`);
  },

  deleteInResourcePath(id, path, payload) {
    return request.delete(`/${resource}/${id}/${path}/`, {
      data: payload,
    });
  },

  deleteInPath(path, id) {
    return request.delete(`/${resource}/${path}/${id}/`);
  },

  deleteInDeepPath(id, path, deep) {
    return request.delete(`/${resource}/${id}/${path}/${deep}`);
  },
});
